<template>
    <div class="solution-environment-page">
        <div class="header-title" style="padding-top: 50px;background: #F3F6F8;font-size: 30px;
font-weight: bold">智慧环保服务内容</div>
        <div class="round-block">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="round-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                <div class="round-item" v-for="item in roundList">
                    <img :src="item.image"/>
                    <div class="mark"></div>
                    <div class="name">{{item.name}}</div>
                </div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
        <div class="info-block">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="info-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                <div class="info-content">
                    <div>
                        智慧环境监控应急服务平台是便捷性的，就是环保一张图。“只要打开地图，选择查询的对象类别，然后在地图的大体位置上缩放，就可以找到想找的地方。环保一张图以盛泽镇的实景地图为蓝本，通过环保部门摸底、调查，确定各个污染源的具体位置，采用GPS定位，添加到环保地图上，最后将各个重点污染源按行业划分。对涉及污染的企业实施24小时监控，一旦企业出现新开业、关闭、地址变更等情况，地图上将会同步更新。环保一张图的准确性配合污染源在线监控系统的实时性，大大提升了监管效率和执法的精准度。
                    </div>
                    <div class="image-block first">
                        <img :src="firstLeft"/>
                        <img :src="firstRight"/>
                    </div>
                    <div class="point-info" v-for="item in pointInfoOne">
                        <div class="title">{{item.title}}</div>
                        <div class="info" v-for="items in item.info">{{items}}</div>
                    </div>
                    <div class="image-block second">
                        <img :src="secondLeft"/>
                        <img :src="secondRight"/>
                    </div>
                    <div class="point-info" v-for="item in pointInfoTwo">
                        <div class="title">{{item.title}}</div>
                        <div class="info" v-for="items in item.info">{{items}}</div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
    </div>
</template>

<script>
    import RoundImage1 from '../../../../../views/image/common/hb_round_img1.png'
    import RoundImage2 from '../../../../../views/image/common/hb_round_img2.png'
    import RoundImage3 from '../../../../../views/image/common/hb_round_img3.png'
    import RoundImage4 from '../../../../../views/image/common/hb_round_img4.png'
    import FirstLeft from '../../../../../views/image/common/image_first_left.png'
    import FirstRight from '../../../../../views/image/common/image_first_right.png'
    import SecondLeft from '../../../../../views/image/common/image_second_left.png'
    import SecondRight from '../../../../../views/image/common/image_second_right.png'
    export default {
        name: "solution-environment-page",
        data(){
            return{
                firstLeft:FirstLeft,
                firstRight:FirstRight,
                secondLeft:SecondLeft,
                secondRight:SecondRight,
                roundList:[
                    {name:'监控一体化',image:RoundImage1},
                    {name:'资源共享化',image:RoundImage2},
                    {name:'决策智能化',image:RoundImage3},
                    {name:'信息透明化',image:RoundImage4},
                ],
                pointInfoOne:[
                    {title:'监控一体化',info:['建立全方位立体监控网络，对水污染源、气污染源、放射源、机动车、水环境、大气环境、噪声、生态环境等进行全面监控，实现天地空监控一体化智能监控管理平台。']},
                    {title:'资源共享化',info:['对跨区域、跨行业及跨平台的环境质量、环境安全和环境风险信息资源实现共享和科学评价，能通过模型和评价体系解决重点城市、区域和流域重大环境管理问题。']},
                    {title:'决策智能化',info:['随时了解实时的环境质量状况，对某个区域的环境质量进行预测预报，同时针对环境质量较差的区域落实限批、停产、关停等环境经济手段。准确核算区域环境资源容载能力，为产业结构调整提供科学依据。']},
                    {title:'信息透明化',info:['通过政务外网网站、企业网上办事大厅及环保APP软件等技术手段，构建政府、企业及市民沟通的桥梁。提供面向排污企业、面向社会、面向百姓的环境信息服务，实现从原来单一的信息发布窗口和行政审批窗口到提供数据服务、接受监督、体现互动交流的公众服务平台的转变。']},
                ],
                pointInfoTwo:[
                    {title:'飞灰填埋云智系统',info:['此系统主要用于产废单位和处置单位之间的工作连接，简化飞灰转移和填埋的工作流程。系统分为PC端和手机APP，分为产废单位、处置单位、环保局等部门，各个部门可使用和查看的功能也不同。系统功能包含首页/概览、联单管理、作业计划、作业管理、检测管理、视频监控等。']},
                    {title:'飞灰填埋云智系统-系统介绍',info:['1.首页/概览: ','生成统计视图，更加直观的展示各个产废或填埋单位的生产或填埋数据，且可通过视频监控查看现场情况。领导层更加方便观察各个产废或填埋单位的工作情况。','2.联单管理: ','将联单进行流程处理，将联单的每一步流程都表示出来，方便管理层查看联单的进度，若飞灰出现问题也可快速找到责任人。\n','3.作业计划: ','处置单位管理员可直接在上面制定周计划和年计划，其他工作人员可直接对计划表格进行查看和打印。','4.作业管理:','处置单位现场管理员可直接在现场使用手机APP进行工作日志和工作相关表格的填写，更加方便了现场工作人员记录表格的填写。','5.检测管理:','检测管理分为产废单位的自检和处置单位的抽检。产废单位检测员可在检测报告这一模块中上传检测样品对应的自检报告；处置单位检测员可使用手机APP去产废单位进行取样抽检，化验过后可直接在PC端或APP上上传抽检报告，如若报告不合格将会发送通知，产废单位将进行再处理。','6.视频监控:','视频监控分为产废单位视频监控和处置单位视频监控。视频监控主要是让单位管理层了解员工具体操作和存储或填埋情况，也为上级领导层提供便捷，方便了解辖区内单位的具体情况。\n']},
                    // {title:'智慧化大数据应用',info: [ '实现一套数、一张图、一个应用', '一套数：统一数据源管理口径，形成环保部门通用一套数。', '一张图：整合环境历史情况、现状趋势、预报预测、溯源分析，形成环境管理一张图。' , '一个应用：以环境数据资源中心为核心，为环保业务提供统一的应用支撑。'] },
                    // {title:'智慧决策中心',info:['构建全面、深入的决策支持及数据辅助分析平台，具体包括以下内容：']},
                    // {title:'智能化应急指挥中心',info:['改变传统“重应急轻预防”的建设模式，以应急准备阶段为建设重点。包括风险源动态管理、风险源风险评估、风险预警管理、应急知识库、应急演练、模型调优、移动应急平台等内容。']},
                    // {title:'智能化大气模拟预测',info:['在模式运行、源清单管理、模拟系统建设三个方面形成与科研机构共建共享的工作模式，实现多模式集合模拟预测、实时动态源解析，同时可以对预测结果进行定期评估分析。另外还可以通过情景模拟，结合环境经济政策等，制订区域化大气治理的方案。']},
                    // {title:'环境数据挖掘与分析',info:['针对不同角色，从提高决策水平、提高管理能力、提高工作效率、提高规范化程度等多个角度对环境数据进行挖掘与分析。']},
                ]
            }
        }
    }
</script>

<style lang="scss" src="./solution-environment-page.scss" scoped>

</style>
